export class RequestError extends Error {
    code;
    status;
    url;
    method;
    data;
    /**
     * Should be serializable
     */
    config;
    constructor(message, options) {
        super(message);
        this.data = options.data;
        this.code = options.code;
        this.url = options.url;
        this.method = options.method;
        this.status = options.status;
        this.config = options.config || {};
        this.name = 'RequestError';
        Object.setPrototypeOf(this, RequestError.prototype);
    }
    static fromAxiosError(error) {
        // We want to support web and mobile custom configurations,
        // so we need to extract the properties that we want to keep by removing the ones we don't want.
        const { adapter, allowAbsoluteUrls, auth, baseURL, beforeRedirect, cancelToken, data, decompress, env, family, fetchOptions, formSerializer, headers, httpAgent, httpsAgent, insecureHTTPParser, lookup, maxBodyLength, maxContentLength, maxRate, maxRedirects, method, noRetry, onDownloadProgress, onUploadProgress, params, paramsSerializer, proxy, responseEncoding, responseType, retried, signal, socketPath, timeout, timeoutErrorMessage, transformRequest, transformResponse, transitional, transport, url, validateStatus, withCredentials, withXSRFToken, xsrfCookieName, xsrfHeaderName, 
        // things like `skipToast` would be here.
        ...config } = error?.response?.config || {};
        const requestError = new RequestError(error.message, {
            code: error.code,
            config: config,
            method: error.config?.method,
            status: error.response?.status,
            url: error.config?.url,
            data: error.response?.data,
        });
        return requestError;
    }
    /**
     * The purpose here is to update the `message` property of the error
     * to be localized and user-friendly.
     * Setting the message is the responsibility of the app (web, admin-portal, mobile, etc.)
     * handled in the interceptors.
     *
     * @param message
     */
    setMessage(message) {
        this.message = message;
    }
}
//# sourceMappingURL=request-error.js.map